export default "__VITE_ASSET__C68Mk1fI__"